class UserData {
  constructor() {
    this.namespaced = true;
    this.state = {
      userData: {
        selectedSyptom:'',
        isNextSteps: false,
        email: '',
        hoverFromScreen:'',
        isEmailSent: false
      }
    },
      this.getters = {
        userData: state => {
          return state.userData;
        },
      },
      this.mutations = {
        saveUserData: () => { },
        markSectionComplete: (state, { section }) => {
          this.state.userData.sectionFlags[section] = true;
        },
        resetSection: (state, { section }) => {
          this.state.userData.sectionFlags[section] = false;
        },
      },

      this.actions = {
        saveUserData: ({ commit }, { data, section }) => {
          commit('saveUserData', { data, section });
        },
        markSectionComplete: ({ commit }, { section }) => {
          commit('markSectionComplete', { section });
        },
        resetSection: ({ commit }, { section }) => {
          commit('resetSection', { section });
        },
      };
  }
}

export default UserData;
